import { createMuiTheme } from "@material-ui/core/styles";
import {
  infoColor,
  grayColor,
} from "assets/jss/index.js";

const theme = createMuiTheme({
  overrides: {
    MuiInput: {
      underline: {
        "&:hover:not($disabled):before,&:before": {
          borderColor: grayColor[4] + " !important",
          borderWidth: "1px !important"
        },
        "&:after": {
          borderColor: infoColor[0] + " !important",
        }
      }
    },
    MuiTableCell: {
      root: {
        fontSize: "12px"
      }
    },
    MuiTypography: {
      h5: {
        fontSize: "1.25rem"
      },
      h6: {
        fontSize: "1.1rem"
      },
    },
    MuiSelect: {
      selectMenu: {
        fontSize: ".9rem"
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: "0"
      }
    }
  }
});


export default theme;
